import { ResourceSection } from "./ResourceSection";
import type { ResourceSection as ResourceSectionType } from "./types";

interface ResourceSectionContainerProps {
  sections: ResourceSectionType[];
}

export const ResourceSectionContainer = ({
  sections,
}: ResourceSectionContainerProps) => (
  <div className="bg-primary border-primary flex flex-col gap-y-4 rounded-2xl border p-4">
    {sections.map(section => (
      <div
        key={section.title}
        className="[&:not(:last-child)]:border-primary [&:not(:last-child)]:border-b [&:not(:last-child)]:pb-4"
      >
        <ResourceSection section={section} />
      </div>
    ))}
  </div>
);
